import * as React from "react";
import * as Highcharts from 'highcharts';
//import drilldown from 'highcharts-drilldown';
import * as AuthStore from "../store/Auth";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { fetchData } from '../utils';
import { busyGif } from '../img';
import { Card, Row, Col } from 'antd';

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class CitDashboardQ3FY25 extends React.Component<AuthProps>
{
    render() {
        return (
            <div className="dashboard" style={{ backgroundColor: 'rgb(240, 242, 245, 0.15)' }}>
                <Helmet>
                    <title>CDR | CIT Dashboard FY25 Q3</title>
                </Helmet>
                <iframe
                    title="Report Section"
                    width="98%"
                    height="1060"
                    src="https://app.powerbi.com/view?r=eyJrIjoiOWJjYTFjZjktYTczNy00MjVhLWIzZGItMTY3Y2RhMjJmYzk0IiwidCI6ImUzMmJlZDhlLWE1OGQtNGIzNi04YzY4LWJkZTBkMTNmZjdhYSIsImMiOjl9"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            </div>
        );
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(CitDashboardQ3FY25 as any);